export const ISSUANCE_REQUEST_STATES = Object.freeze({
  pending: 1,
  cancelled: 2,
  approved: 3,
  rejected: 4,
  permanentlyRejected: 5
})



// WEBPACK FOOTER //
// ./src/js/const/issuance_request_states.const.js